<div class="card mb-5">
  <div class="container section-container">
    <section class="form-section">
      <h3>Comunicaciones</h3>
      @if (is_connected()) {
        <p class="section-intro">
          Slack conectado al workspace <code>{{ slack_external_tenant_id() }}</code
          >.
        </p>
        <div class="actions-row">
          <button mat-stroked-button type="button" (click)="open_workspace()">
            <mat-icon>open_in_new</mat-icon>
            Ver workspace Slack
          </button>
          @if (can_edit()) {
            <button mat-stroked-button color="warn" type="button" (click)="disconnect()" [disabled]="disconnecting()">
              <mat-icon>link_off</mat-icon>
              {{ disconnecting() ? 'Desconectando…' : 'Desconectar Slack' }}
            </button>
          }
        </div>
      } @else if (can_edit()) {
        <p class="section-intro">
          Conecta el workspace Slack de esta empresa. Se instalará la App de Bisual y quedará registrado solo para esta company.
        </p>
        <button mat-flat-button color="accent" type="button" (click)="connect()" [disabled]="connecting()">
          <mat-icon>add_link</mat-icon>
          {{ connecting() ? 'Abriendo Slack…' : 'Conectar Slack' }}
        </button>
      } @else {
        <p class="status-line status-line--pending">
          <mat-icon>info</mat-icon>
          Slack no conectado
        </p>
      }

      <h3 class="mt-4">Microsoft Teams</h3>
      @if (has_teams_tenant()) {
        <p class="status-line status-line--ok">
          <mat-icon>check_circle</mat-icon>
          Configurado
        </p>
        <ul class="linked-list">
          @for (tenant of microsoft_tenants(); track tenant.id) {
            <li>
              <strong>{{ tenant.label }}</strong>
              <code>{{ tenant.tenant_id }}</code>
            </li>
          }
        </ul>
        <div class="actions-row">
          @if (can_edit()) {
            <a mat-stroked-button routerLink="/employees/configuration/workspaces">
              <mat-icon>hub</mat-icon>
              Gestionar workspaces
            </a>
          }
          <button mat-stroked-button type="button" (click)="download_teams_app_package()" [disabled]="downloading_teams_package()">
            <mat-icon>download</mat-icon>
            {{ downloading_teams_package() ? 'Descargando…' : 'Descargar ZIP de la app' }}
          </button>
        </div>
      } @else {
        <p class="status-line status-line--pending">
          <mat-icon>info</mat-icon>
          Sin tenant asignado
        </p>
        <p class="section-intro">Para configurar Teams en esta empresa, el cliente debe:</p>
        <ol class="setup-steps">
          <li>
            Descargar el paquete ZIP de la app <strong>Bisual</strong> e instalarlo en su tenant de Microsoft Teams (Apps → Administrar apps
            → Cargar una app personalizada).
          </li>
          <li>Añadir la app a los chats, grupos o canales donde Bisual deba leer/enviar mensajes.</li>
          <li>Avisar a Bisual para vincular el tenant a esta empresa.</li>
        </ol>
        <button mat-stroked-button type="button" (click)="download_teams_app_package()" [disabled]="downloading_teams_package()">
          <mat-icon>download</mat-icon>
          {{ downloading_teams_package() ? 'Descargando…' : 'Descargar ZIP de la app' }}
        </button>
      }

      <h3 class="mt-4">Google Chat</h3>
      @if (has_google_customer()) {
        <p class="status-line status-line--ok">
          <mat-icon>check_circle</mat-icon>
          Configurado
        </p>
        <ul class="linked-list">
          @for (customer of google_chat_customers(); track customer.id) {
            <li>
              <strong>{{ customer.label }}</strong>
            </li>
          }
        </ul>
        @if (can_edit()) {
          <a mat-stroked-button routerLink="/employees/configuration/workspaces">
            <mat-icon>hub</mat-icon>
            Gestionar workspaces
          </a>
        }
      } @else {
        <p class="status-line status-line--pending">
          <mat-icon>info</mat-icon>
          Sin customer asignado
        </p>
        <p class="section-intro">Para configurar Google Chat en esta empresa:</p>
        <ol class="setup-steps">
          <li>
            El cliente debe tener espacios/DMs de Google Chat accesibles para la cuenta de servicio Bisual (delegación de dominio donde
            aplique).
          </li>
          <li>Avisar a Bisual para sincronizar y vincular el customer a esta empresa.</li>
        </ol>
        @if (can_edit()) {
          <a mat-stroked-button routerLink="/employees/configuration/workspaces">
            <mat-icon>hub</mat-icon>
            Ir a Workspaces
          </a>
        }
      }
    </section>
  </div>
</div>
